import React, { useState } from 'react';
import useApi from '../../hooks/useApi';
import { useNavigate, Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import PageContainer from '../../components/common/PageContainer';

const BatchBulkUploadPage = () => {
  const api = useApi();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const onFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
    setError(null);
    setResult(null);
  };

  const handleUpload = async () => {
    setError(null);
    setResult(null);
    if (!file) {
      setError('Select a CSV file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setLoading(true);
    try {
      const resp = await api.post('batches/bulk-upload/csv', formData);
      const data = resp?.data ?? resp;
      setResult(data);
    } catch (err) {
      console.error('Bulk upload failed', err);
      setError(err?.message || 'Upload failed. Check CSV format and server logs.');
    } finally {
      setLoading(false);
    }
  };

  const downloadSample = () => {
    const sample = `productId,batchNumber,expiryDate,quantity,purchasePrice,sellPrice,note,storeId
"68c666b12f8c49cc7b67fdee","BATCH-10001","2025-09-16",100,30.00,45.00,"Received from supplier X","686c89bc2928142439d427cd"
`;
    const blob = new Blob([sample], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'batches_sample.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <Layout>
      <PageContainer title="Batches / Bulk Upload">
        <div className="p-4 max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div>
              <div className="text-sm text-gray-500">
                <Link to="/batches" className="text-indigo-600 hover:underline">Batches</Link> / Bulk Upload
              </div>
              <h1 className="text-2xl font-semibold mt-1">Bulk Upload Batches (CSV)</h1>
              <p className="text-sm text-gray-600 mt-1">Upload batches in bulk. Use the sample CSV to match required column names.</p>
            </div>

            <div className="flex items-center gap-2">
              <button onClick={downloadSample} className="px-3 py-1 bg-gray-100 rounded border">Download sample</button>
              <Link to="/batches" className="px-3 py-1 border rounded bg-white">Back to list</Link>
            </div>
          </div>

          <div className="bg-white border rounded p-4 shadow-sm">
            <div className="mb-3 text-sm text-gray-700">
              Expected CSV columns: productId,batchNumber,expiryDate,quantity,purchasePrice,sellPrice,note,storeId
            </div>

            <div className="mb-3">
              <input type="file" accept=".csv,text/csv" onChange={onFileChange} />
            </div>

            {error && <div className="text-sm text-red-600 mb-2">{error}</div>}
            {result && <pre className="p-2 bg-gray-100 text-sm rounded mb-2 overflow-auto">{JSON.stringify(result, null, 2)}</pre>}

            <div className="flex gap-2">
              <button onClick={() => navigate(-1)} className="px-3 py-1 border rounded">Back</button>
              <button onClick={handleUpload} disabled={loading} className="px-4 py-2 bg-indigo-600 text-white rounded">
                {loading ? 'Uploading...' : 'Upload CSV'}
              </button>
            </div>
          </div>
        </div>
      </PageContainer>
    </Layout>
  );
};

export default BatchBulkUploadPage;